import { AsyncPipe, CommonModule, KeyValue } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { Observable, Subject, map, takeUntil } from 'rxjs';
import { RatingExportsModule } from 'src/app/extensions/rating/exports/rating-exports.module';

import { FeatureToggleDirective } from 'ish-core/directives/feature-toggle.directive';
import { ServerHtmlDirective } from 'ish-core/directives/server-html.directive';
import { ProductContextDisplayProperties, ProductContextFacade } from 'ish-core/facades/product-context.facade';
import { AttributeGroup } from 'ish-core/models/attribute-group/attribute-group.model';
import { ProductView } from 'ish-core/models/product-view/product-view.model';
import { ProductHelper } from 'ish-core/models/product/product.helper';
import { AccordionItemComponent } from 'ish-shared/components/common/accordion-item/accordion-item.component';
import { AccordionComponent } from 'ish-shared/components/common/accordion/accordion.component';
import { ProductAttachmentsComponent } from 'ish-shared/components/product/product-attachments/product-attachments.component';
import { ProductAttributesComponent } from 'ish-shared/components/product/product-attributes/product-attributes.component';

@Component({
  selector: 'ish-product-detail-info',
  templateUrl: './product-detail-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    ServerHtmlDirective,
    ProductAttachmentsComponent,
    AsyncPipe,
    TranslateModule,
    NgbNavModule,
    ProductAttributesComponent,
    RatingExportsModule,
    AccordionItemComponent,
    AccordionComponent,
    FeatureToggleDirective,
  ],
})
export class ProductDetailInfoComponent implements OnInit, OnDestroy {
  product$: Observable<ProductView>;
  isVariationMaster$: Observable<boolean>;
  active = 'DESCRIPTION'; // default product tab
  private destroy$ = new Subject<void>();

  constructor(private context: ProductContextFacade) {}

  ngOnInit() {
    this.product$ = this.context.select('product');
    // when routing between products reset the opened product tab to the default tab
    this.context
      .select('sku')
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => (this.active = 'DESCRIPTION'));

    this.isVariationMaster$ = this.context.select('product').pipe(map(ProductHelper.isMasterProduct));
  }

  generateProductTabs(attributeGroup: AttributeGroup): Map<string, string> {
    const tabsMap = new Map();

    const allProductAttributes = attributeGroup.attributes;
    const tempTabsMap = new Map();

    allProductAttributes.forEach(element => {
      tempTabsMap.set(element.name, element.value);
    });

    if (tempTabsMap.has('Tab2Name') && tempTabsMap.has('Tab2Value')) {
      tabsMap.set(tempTabsMap.get('Tab2Name'), tempTabsMap.get('Tab2Value'));
    }
    if (tempTabsMap.has('Tab3Name') && tempTabsMap.has('Tab3Value')) {
      tabsMap.set(tempTabsMap.get('Tab3Name'), tempTabsMap.get('Tab3Value'));
    }
    if (tempTabsMap.has('Tab4Name') && tempTabsMap.has('Tab4Value')) {
      tabsMap.set(tempTabsMap.get('Tab4Name'), tempTabsMap.get('Tab4Value'));
    }
    if (tempTabsMap.has('Tab5Name') && tempTabsMap.has('Tab5Value')) {
      tabsMap.set(tempTabsMap.get('Tab5Name'), tempTabsMap.get('Tab5Value'));
    }

    return tabsMap;
  }
  configuration$(key: keyof ProductContextDisplayProperties) {
    return this.context.select('displayProperties', key);
  }
  originalOrder = (_a: KeyValue<string, string>, _b: KeyValue<string, string>): number => 0;

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
